<template>
  <amf-form :title="title" class="container">
    <div class="form-group" v-if="!busy">
      <!-- <h1>Nacha - {{}}</h1> -->
      <table class="table table-hover table-bordered table-sm mt-3 table-accounts">
        <thead>
          <tr>
            <th>Participant</th>
            <th>Created Date</th>
            <th>Payment Amount</th>
            <th>Payment Status</th>
            <th>Status Date</th>
            <th>{{ifReimbursement ? "Actions" : "Rejected Reason" }}</th>
          </tr>
        </thead>
        <tbody v-for="(p, index) in payments" :key="index">
          <tr>
            <td style="width: 15%">
             <span v-if="ifReimbursement"><a href="#" @click.prevent="editBankAccount(p, true)">{{p.fullName}}</a></span>
            <span v-else>{{p.fullName}}</span>
            </td>
            <td style="width: 15%">{{$formatters.date(p.createdAt)}}</td>
            <td style="width: 15%">${{p.paymentAmount}}</td>
            <td style="width: 15%">
              <span v-if="p.processingStatus > 6">{{getStatus(p.processingStatus)}}</span>
              <span v-else>
                <amf-select v-model="p.processingStatus" :options="nachaLabels.statuses" :columns="3" />
              </span>
            </td>
            <td style="width: 15%">
               <span v-if="p.statusDate">{{$formatters.date(p.statusDate)}}</span>
                <span v-else></span>
            </td>
            <td style="width: 25%">
              <span v-if="p.processingStatus == 5 && !ifReimbursement">
                <amf-select
                  v-model="p.response"
                  caption="--Select--"
                  :options="nachaLabels.rejectOptions"
                  :columns="3"
                />
                <span
                  class="error-div"
                  v-if="$v.payments.$each[index].response.$invalid"
                >Response is required</span>
              </span>
              <span v-if="p.processingStatus == 5 && ifReimbursement && !p.readOnly">
               <span v-if="p.isBankInfoChanged"><a href="#" @click.prevent="editBankAccount(p, false)">Bank info</a> / </span>
                <a href="#" @click.prevent="sendCheck(p.bankTransferId)">Send check</a>

              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </amf-form>
</template>

<script>
import BankInfo from "./BankInfo";
import {nachaLabels} from "./nacha-labels";

export default {
  data() {
    return {
      payments: [],
      nachaStatus: null,
      nachaId:null,
      nachaLabels: nachaLabels,
    };
  },
  computed: {
    footerButtons() {
      if(this.nachaStatus == 1) return "Save/Close";
      return "Save/Set All As Confirmed/Close"
    },
    type() {
      return this.$route.query.typeId
    },
    ifReimbursement()
    {
        return [1,3].includes(this.type);
    },
    title()
    {
       return  _.find(this.nachaLabels.nachaTypes, {id:this.type}).name;
  }
  },
  methods: {
    async load() {
      this.nachaId = this.$route.params.nachaId;

      var nachaDetail = await romeApi.get(
        `participant/nacha/${this.nachaId}/detail`, {typeId:this.type});
      this.nachaStatus = 1;
      nachaDetail.forEach(n=>
      {
        if(n.processingStatus <5) this.nachaStatus = 0;
      });


      this.payments = nachaDetail;

    },
    async editBankAccount(p, readOnly) {
      var res = await modalService.show("bankInfo", BankInfo, {
        participantId: p.participantId,
        bankTransferId: p.bankTransferId,
        readOnly: readOnly,
        title: "Bank Info",
      });

     if(res) this.load();

    },
    async sendCheck(pid)
    {
        this.busy = true;
        var data = {
            bankTransferId: pid
        };

        let res = await romeApi.post("participant/nacha/sendcheck", data);
        if(res.success)
        {
          toastService.success("Check sent.");
        }
        else
        {
          toastService.error(res.message);
        }

        this.busy = false;
        this.load();
    },
    setAllAsConfirmed()
    {
        this.payments.forEach(p => {if(p.processingStatus<6){p.processingStatus =6} });
    },
    getStatus(status) {
      return this.nachaLabels.allStatuses.find(x => x.id == status).name;
    },
    async save() {
      if (this.$v.$invalid) {
        return false;
      }
      this.payments.forEach(x=>
      {
          if(x.processingStatus == 6){
              x.response = null;
          }
      });
      var data = {nachaPayments: this.payments, nachaType: this.type }
      await romeApi.post(`participant/nacha/${this.$route.params.nachaId}/save`, data)
      toastService.success("Nacha updated.");
      this.load();
    },
  },
  created() {
    this.load();
  },
  validations() {
    return {
      payments: {
        $each: {
          response: v.build(v.requiredIf(x=>x.processingStatus == 5 && !this.ifReimbursement)),
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/finance/NachaDetail.vue